// src/components/cuenta/ProfileMenu.js
import React from 'react';
import './ProfileMenu.css';

// Componente `LogoutIcon` que renderiza esta parte de la interfaz.
const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

// Componente `AdminIcon` que renderiza esta parte de la interfaz.
const AdminIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <circle cx="12" cy="11" r="3"></circle>
  </svg>
);

// Componente `AccionesIcon` que renderiza esta parte de la interfaz.
const AccionesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
  </svg>
);

// Componente `AsambleasIcon` que renderiza esta parte de la interfaz.
const AsambleasIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

// Componente `PoderesIcon` que renderiza esta parte de la interfaz.
const PoderesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <path d="M12 18v-6"></path>
    <path d="M9 15l3 3 3-3"></path>
  </svg>
);

// Componente `ReceiptIcon` que renderiza esta parte de la interfaz.
const ReceiptIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position: 'relative', top: '-1px' }}>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
    <line x1="16" y1="8" x2="8" y2="8"></line>
    <line x1="16" y1="12" x2="8" y2="12"></line>
    <line x1="10" y1="16" x2="8" y2="16"></line>
  </svg>
);

// Componente `InboxIcon` que renderiza esta parte de la interfaz.
const InboxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
  </svg>
);

// Componente `ProfileMenu` que renderiza esta parte de la interfaz.
export default function ProfileMenu({ userName, onNavigate, onLogout, isAdmin = false, isNotario = false, onNotarioPortal, notarioLoading = false, portalError = '', t = {} }) {
  
  // Función `handleAdminClick` que gestiona la interacción o el evento correspondiente.
  const handleAdminClick = () => {
    onNavigate('admin');
  };

  // Función `handleProfileNavigate` que gestiona la interacción o el evento correspondiente.
  const handleProfileNavigate = (section, tab) => {
    onNavigate(section, tab);
    window.dispatchEvent(new CustomEvent('forceProfileTabChange', { detail: tab }));
  };

  return (
    <div className="profile-dropdown-menu">
      {/* Encabezado con saludo. */}
      <div className="menu-header">
        <span className="user-greeting">Hola, {userName}</span>
        {isAdmin && (
          <span className="admin-badge">Admin</span>
        )}
      </div>
      
      <ul className="menu-list">
        
        {/* GRUPO 1: NAVEGACIÓN PRINCIPAL (DOCUMENTOS) */}
        <li className="menu-group-label">Documentos Legales</li>
        
        {/* Notario: acceso a los poderes/expedientes que le llegaron */}
        {isNotario && (
          <li>
            {portalError && <p role="alert" className="profile-portal-error">{portalError}</p>}
            <button disabled={notarioLoading} onClick={onNotarioPortal || (() => onNavigate('notario-dashboard'))}>
              <span className="menu-item-content">
                <InboxIcon />
                <span>{notarioLoading ? 'Abriendo portal…' : t.menuPortalNotaria || 'Portal de notaría'}</span>
              </span>
            </button>
          </li>
        )}
        
        <li>
          <button onClick={() => handleProfileNavigate('profile', 'boletas')}>
            <span className="menu-item-content">
              <AccionesIcon />
              <span>{t.menuAcciones || 'Mis Acciones'}</span>
            </span>
          </button>
        </li>
        <li>
          <button onClick={() => handleProfileNavigate('profile', 'asambleas')}> 
            <span className="menu-item-content">
              <AsambleasIcon />
              <span>{t.menuAsambleas || 'Mis Asambleas'}</span>
            </span>
          </button>
        </li>
        <li>
          <button onClick={() => handleProfileNavigate('profile', 'poderes')}>
            <span className="menu-item-content">
              <PoderesIcon />
              <span>{t.menuPoderes || 'Mis Poderes'}</span>
            </span>
          </button>
        </li>

        <li className="separator"></li>

        {/* GRUPO 2: GESTIÓN DE LA CUENTA / POSTVENTA */}
        <li className="menu-group-label">Gestión de Cuenta</li>

        <li>
          <button onClick={() => onNavigate('facturacion')}>
            <span className="menu-item-content">
              <ReceiptIcon />
              <span>{t.menuFacturacion || 'Facturación'}</span>
            </span>
          </button>
        </li>

        {/* GRUPO 3: ADMIN (Oculto para usuarios normales) */}
        {isAdmin && (
          <>
            <li className="separator"></li>
            <li className="menu-group-label">Sistema</li>
            <li>
              <button onClick={handleAdminClick} className="admin-option">
                <span className="menu-item-content">
                  <AdminIcon />
                  <span>Panel de Administración</span>
                </span>
              </button>
            </li>
          </>
        )}

        <li className="separator"></li>

        {/* CERRAR SESIÓN */}
        <li>
          <button onClick={onLogout} className="logout-option">
            <span>{t.cerrarSesion || 'Cerrar Sesión'}</span>
            <LogoutIcon />
          </button>
        </li>
      </ul>
    </div>
  );
}
